import * as React from 'react';
import * as time from '@tock/shared/utils/time';
import { IntlShape, injectIntl } from 'react-intl';
import { LocalDate } from 'js-joda';
import { noop } from 'es-toolkit';
import { range, toNumber } from 'es-toolkit/compat';
import Select from '@tock/shared/components/inputs/Select';

// exported for testing
export const fromYears = 20;
export const toYears = 5;
export const currentYear = new Date().getFullYear();
const fromMonth = new Date(currentYear - fromYears, 0);
const toMonth = new Date(currentYear + toYears, 11);

interface Props {
  date: Date;
  onChange: (date: Date) => void;
  intl: IntlShape;
}

class YearMonthPicker extends React.PureComponent<Props> {
  handleChangeMonth = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.onChange(new Date(this.props.date.getFullYear(), toNumber(e.target.value)));
  };

  handleChangeYear = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.props.onChange(new Date(toNumber(e.target.value), this.props.date.getMonth()));
  };

  render() {
    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
      years.push(i);
    }
    const { intl } = this.props;
    return (
      <div className="DayPicker-Caption">
        <Select
          modifierClassName="Select--embed"
          field={{
            value: this.props.date.getMonth(),
            onBlur: noop,
            onChange: this.handleChangeMonth,
          }}
          options={range(0, 12).map((month: number) => ({
            value: month,
            key: month,
            label: time.formatDate(
              intl,
              LocalDate.of(this.props.date.getFullYear(), month + 1, 1),
              {
                timeZone: 'UTC',
                month: 'long',
              }
            ),
          }))}
          data-testid="month-select"
        />

        <Select
          modifierClassName="Select--embed"
          field={{
            value: this.props.date.getFullYear(),
            onBlur: noop,
            onChange: this.handleChangeYear,
          }}
          options={years.map((year) => ({
            value: year,
            key: year,
            label: String(year),
          }))}
          data-testid="year-select"
        />
      </div>
    );
  }
}

export default injectIntl(YearMonthPicker);
